import clsx from 'clsx'
import { DefaultSidebar } from '@/General/ContentWrapper/DefaultSidebar'

export const ContentWrapper = ({
  children,
  className,
  sidebar,
  hasSidebar = false,
  /** No outer horizontal/top padding — for full-bleed heroes that sit flush under the nav */
  flushWithSiteHeader = false,
  /** Top padding only removed; horizontal padding unchanged (e.g. full-bleed hero flush under nav) */
  flushTop = false,
}: ContentWrapperProps) => {
  const paddingClass = flushWithSiteHeader
    ? 'px-0 pt-0'
    : flushTop
      ? 'px-4 xl:px-0 pt-0'
      : 'px-4 xl:px-0 pt-4 md:pt-6'

  return (
    <div
      className={clsx('max-w-(--breakpoint-xl) mx-auto mb-12', paddingClass, className)}
    >
      <div className={`flex ${hasSidebar ? 'flex-col lg:flex-row' : 'flex-col'}`}>
        {hasSidebar && <aside>{sidebar || <DefaultSidebar />}</aside>}
        <main className="grow min-w-0">{children}</main>
      </div>
    </div>
  )
}

interface ContentWrapperProps {
  children: React.ReactNode
  className?: string
  sidebar?: React.ReactNode
  hasSidebar?: boolean
  flushWithSiteHeader?: boolean
  flushTop?: boolean
}
